export default function SkeletonCard({ className }: { className?: string }) {
	return (
		<div data-testid='skeletonCard' className={`bg-white pt-2 p-4 w-full ${className ?? 'rounded-lg'}`}>
			<div className='w-[120px] h-6 bg-blue-grey-lightest rounded mb-2'></div>
			<hr className='border-dashed' />
			<div className='mt-4 flex flex-col gap-2'>
				<div className='flex justify-between'>
					<div className='w-[120px] h-6 bg-blue-grey-lightest rounded'></div>
					<div className='w-[120px] h-6 bg-blue-grey-lightest rounded'></div>
				</div>
				<div className='flex justify-between'>
					<div className='w-[120px] h-4 bg-blue-grey-lightest rounded'></div>
					<div className='w-[72px] h-4 bg-blue-grey-lightest rounded'></div>
				</div>
			</div> 
		</div>
	);
}
